import React from 'react';

import RoleSideNav from './RoleSideNav';
import { ADMIN_NAV_GROUPS, NavContext } from './sideNavConfig';

const ADMIN_CONTEXT: NavContext = {
  isSpectator: false,
  isReadOnly: false,
};

const AdminNavbar: React.FC = () => (
  <RoleSideNav
    context={ADMIN_CONTEXT}
    groups={ADMIN_NAV_GROUPS}
    ariaLabel="Admin navigation"
    collapseStorageKey="gc_admin_nav_collapsed_v1"
    openStorageKey="gc_admin_nav_open_v1"
  />
);

export default AdminNavbar;
